import { api } from './httpClient';

export const walletApi = {
  balance: () => api('/wallet/balance'),
  transactions: () => api('/wallet/transactions'),
  banks: (query) => api(`/wallet/banks${query ? `?q=${encodeURIComponent(query)}` : ''}`),
  lookupIfsc: (code) => api(`/wallet/ifsc/${encodeURIComponent(code)}`),
  upiConfig: () => api('/wallet/upi-config'),
  bankAccounts: () => api('/wallet/bank-accounts'),
  addBankAccount: (body) =>
    api('/wallet/bank-accounts', { method: 'POST', body: JSON.stringify(body) }),
  setDefaultBankAccount: (id) =>
    api(`/wallet/bank-accounts/${id}/default`, { method: 'PATCH' }),
  deleteBankAccount: (id) =>
    api(`/wallet/bank-accounts/${id}`, { method: 'DELETE' }),
  submitDeposit: (amount, utr) =>
    api('/wallet/deposit-request', {
      method: 'POST',
      body: JSON.stringify({ amount, utr }),
    }),
  depositRequests: () => api('/wallet/deposit-requests'),
  submitWithdraw: (bankAccountId, amount) =>
    api('/wallet/withdraw-request', {
      method: 'POST',
      body: JSON.stringify({ bankAccountId, amount }),
    }),
  withdrawRequests: () => api('/wallet/withdraw-requests'),
};
